import { isEmpty, isNil } from "lodash";
import { logEventName } from "../constants";
import * as rudderanalytics from "rudder-sdk-js";
import webviewChecker from "./webview-checker";

const operator = "Mobily";
const isWebview = webviewChecker();
const isBlank = (val) => isEmpty(val) || isNil(val);

export function packageRequestEvent(
  phone = "",
  subscriptionTypeId = "",
  success,
  error
) {
  rudderanalytics.track(logEventName.packagesRequested, {
    msisdn: phone,
    subscriptionTypeId,
    isWebview,
    operator,
    success,
    ...(!isBlank(error) && {
      error: {
        code: error?.code || 0,
        details: error?.name || "",
        error: {
          code: error?.code,
          details: error?.name || "",
          message: error?.message || "",
        },
      },
    }),
  });
}

export function phoneNumberSubmittedEvent(
  phone = "",
  subscriptionTypeId = "",
  success,
  error
) {
  rudderanalytics.track(logEventName.phoneNumberSubmitted, {
    msisdn: phone,
    subscriptionTypeId,
    isWebview,
    operator,
    success,
    ...(!isBlank(error) && {
      error: {
        code: error?.code || 0,
        details: error?.name || "",
        error: {
          code: error?.code,
          details: error?.name || "",
          message: error?.message || "",
        },
      },
    }),
  });
}

export function otpSubmittedEvent(
  phone = "",
  subscriptionTypeId = "",
  success,
  error
) {
  rudderanalytics.track(logEventName.otpSubmitted, {
    msisdn: phone,
    subscriptionTypeId,
    isWebview,
    operator,
    success,
    ...(!isBlank(error) && {
      error: {
        code: error?.code || 0,
        details: error?.name || "",
        error: {
          code: error?.code,
          details: error?.name || "",
          message: error?.message || "",
        },
      },
    }),
  });
}

export function otpResendEvent(
  phone = "",
  subscriptionTypeId = "",
  success,
  error
) {
  rudderanalytics.track(logEventName.resendOtp, {
    msisdn: phone,
    subscriptionTypeId,
    isWebview,
    operator,
    success,
    ...(!isBlank(error) && {
      error: {
        code: error?.code || 0,
        details: error?.name || "",
        error: {
          code: error?.code,
          details: error?.name || "",
          message: error?.message || "",
        },
      },
    }),
  });
}

export function paymentFinishedEvent(
  phone = "",
  subscriptionTypeId = "",
  success
) {
  rudderanalytics.track(logEventName.paymentFinished, {
    msisdn: phone,
    subscriptionTypeId,
    isWebview,
    operator,
    success,
  });
}

export function screenViewEvent() {
  rudderanalytics.track(logEventName.screenView, {
    isWebview,
    operator,
  });
}
